import { render, staticRenderFns } from "./errors.vue?vue&type=template&id=24867ee2&scoped=true&"
import script from "./errors.vue?vue&type=script&lang=js&"
export * from "./errors.vue?vue&type=script&lang=js&"
import style0 from "./errors.vue?vue&type=style&index=0&id=24867ee2&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24867ee2",
  null
  
)

export default component.exports